import { Button } from 'antd'
import styled from 'styled-components'

export const StyledButtonsContainer = styled.div<{ sideBarWidth: number }>`
  width: ${({ sideBarWidth }) => `calc(100% - ${sideBarWidth}px)`};
  min-height: 80px;
  height: fit-content;

  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 16px;
  justify-content: flex-end;
  align-items: center;
`

export const StyledButton = styled(Button)`
  background-color: #219653 !important;
  border-color: #219653 !important;
  width: 343px;
  height: 48px;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`

export const StyledLightButton = styled(Button)`
  min-width: fit-content;
  width: 200px;
  height: 48px;

  background-color: #fefefe !important;
  color: #90258c !important;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`
